import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  memo,
} from "react";
import { Image, Modal, Button } from "react-bootstrap";
import NewAppointment from "../popups/NewAppointment";
import { useParams, useHistory } from "react-router-dom";
import axiosInstance from "../../axios/axios";
import { BsCheckCircle } from "react-icons/bs";
import rect from "../../assets/images/Rectangle_761.webp";
import PatientSubNav from "../../components/Sidenav/PatientSubNav";
import Patientemail from "../../assets/images/Patientemail.png";
import Patientfax from "../../assets/images/Patientfax.png";
import Primaryprovider from "../../assets/images/Primaryprovider.png";
import Patientmobile from "../../assets/images/Patientmobile.png";
import { useSelector } from "react-redux";
import { fileTypes, fileurl, generateFileURL } from "../../axios/url.js";
import { parsePhoneForDisplay } from "./ParsePhoneForDisplay.js";
import axios from "axios";

var CryptoJS = require("crypto-js");

const Encode_Decode_JSON = {
  stringify: function (DecodingVal) {
    var Data_Val = {
      Encode: DecodingVal.ciphertext.toString(CryptoJS.enc.Base64),
    };
    if (DecodingVal.iv) Data_Val.Decentral = DecodingVal.iv.toString();
    if (DecodingVal.salt) Data_Val.EndCode = DecodingVal.salt.toString();
    return JSON.stringify(Data_Val);
  },
  parse: function (StrVal) {
    var Data_Val = JSON.parse(StrVal);
    var DecodingVal = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(Data_Val.Encode),
    });
    if (Data_Val.Decentral)
      DecodingVal.Decentral = CryptoJS.enc.Hex.parse(Data_Val.Decentral);
    if (Data_Val.EndCode)
      DecodingVal.salt = CryptoJS.enc.Hex.parse(Data_Val.EndCode);

    return DecodingVal;
  },
};

const Decrypt_Value = (data, key) => {
  return JSON.parse(
    CryptoJS.AES.decrypt(data, key, {
      format: Encode_Decode_JSON,
    }).toString(CryptoJS.enc.Utf8)
  );
};

const DemographicsPatientDetail = (props, ref) => {
  //------------------------------------------State and Variables Start------------------------------------------//

  let history = useHistory();
  const [showApp, setShowApp] = useState(false);
  const [rows, setfutureId] = useState([]);
  const [demoini, setdemoini] = useState(props.demostat);
  const [modalAlerShow, setModalAlerShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [redirectTo, setRedirectTo] = useState(false);
  const params = useParams();
  const [startDate, setStartDate] = useState("");
  const [openEmail, setOpenEmail] = useState("");
  const [imgError, setImgError] = useState(false);
  const [countryCodes, setCountryCodes] = useState([]);
  var storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  var uid = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  var ufc = Decrypt_Value(localStorage.getItem("facility_id"), "vozo");

  var provarray = [Decrypt_Value(localStorage.getItem("user_id"), "vozo")];
  var facarray = [Decrypt_Value(localStorage.getItem("facility_id"), "vozo")];

  var DBHost = Decrypt_Value(localStorage.getItem("DBHost"), "vozo");
  var authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  const main_facility = Decrypt_Value(
    localStorage.getItem("main_facility"),
    "vozo"
  );
  const main_pro =
    localStorage.getItem("main_pro") &&
    Decrypt_Value(localStorage.getItem("main_pro"), "vozo");

  //------------------------------------------State and Variables End------------------------------------------//

  //------------------------------------------Functions Start------------------------------------------//

  const handleCloseApp = () => setShowApp(false);

  const handleShowApp = (patEmail = "") => {
    if (storedNames.appt1_viewOnly) {
      alert("You only have view-only access.");
    } else {
      setShowApp(true);
    }
    if (!patEmail || patEmail.trim() === "") {
      setOpenEmail(true);
    } else {
      setOpenEmail(false);
    }
  };

  const Redirect = () => {
    setRedirectTo(true);
  };
  const moveTo = (value) => {
    if (value === "redirect") {
      setRedirectTo(false);
    } else if (value === "continue") {
      history.push("/settings/settingpracticeinfo");
    }
  };

  useImperativeHandle(ref, () => ({
    demographicdetailchange() {
      setdemoini(!demoini);
    },
  }));

  const saveAlertMsg = (a, b) => {
    setShowApp(false);
    setModalAlerShow(b);
    setModalMsg(a);
  };

  const modClose = () => setModalAlerShow(false);

  const fetchapptdemo = () =>
    setTimeout(
      () =>
        history.push("/schedule/calender", {
          apptStartDate: startDate,
        }),
      2000
    );

  const spinnfunc = () => console.log("Don't remove this function");
  const [navData1, setNavData1] = useState("iconclose");

  var NavData1 = useSelector((state) => state.Schedule?.NavData);

  const getStartApptDate = (date) => {
    setStartDate(date);
  };
  //------------------------------------------Functions End------------------------------------------//

  //------------------------------------------useEffect Start------------------------------------------//

  useEffect(() => {
    const fetchPatient = () => {
      axiosInstance
        .get("/vozonew/patient?pid=" + params.pid)
        .then((response) => {
          let DecodingVal = Decrypt_Value(response.data, "vozo");
          setfutureId([DecodingVal]);
        })
        .catch((e) => {
          console.log(e);
        });
    };

    // First load
    fetchPatient();

    // Listen for custom reload event
    const handleReload = async () => {
      await fetchPatient();
    };

    window.addEventListener("reload-patient-data", handleReload);

    // Cleanup
    return () => {
      window.removeEventListener("reload-patient-data", handleReload);
    };
  }, [params.pid, demoini]);

  useEffect(() => {
    if (NavData1 !== "") {
      setNavData1(NavData1);
    }
  }, [NavData1]);

  useEffect(() => {
    const handleCountryFetch = async () => {
      await axios
        .get(fileurl + "/interface/register/get_country_code_rpm.php")
        .then((res) => {
          setCountryCodes(res.data);
        })
        .catch((err) => {
          console.error(err.message);
          setCountryCodes([]);
        });
    };

    handleCountryFetch();
  }, []);
  //------------------------------------------useEffect End------------------------------------------//

  return (
    <>
      <div className="pat-left-div">
        <div>
          {rows.map((row, ind) => (
            <div
              key={row.pid}
              className={
                (navData1 === "iconopen" && "pat-image-right2") ||
                (navData1 === "iconclose" && "pat-image-right4")
              }
            >
              <div key={ind} className="d-flex patient-pro-data">
                {!imgError && row.img_url !== null ? (
                  <Image
                    height="40px"
                    width="40px"
                    src={generateFileURL(fileTypes.profileimages, row.img_url)}
                    alt="pic"
                    loading="lazy"
                    className="b-R-40"
                    onError={() => setImgError(true)}
                  />
                ) : (
                  <div className="patname_first patname_dashboard1 dashboard_img">
                    {row.fname ? row.fname.charAt(0).toUpperCase() : "D"}
                  </div>
                )}
                <div
                  title={`${row.fname ? row.fname + " " : "Sample "}${row.mname ? row.mname + " " : ""}${row.lname ? row.lname + " " : "Provider"}`}
                  style={{ marginLeft: "8px", textAlign: "left" }}
                >
                  <span>
                    {`${row.fname ? row.fname + " " : "Sample "}${row.mname ? row.mname + " " : ""}${row.lname ? row.lname + " " : "Provider"}`.slice(0, 15)}
                    {/* adjust length as needed */}
                    {`${row.fname ? row.fname + " " : "Sample "}${row.mname ? row.mname + " " : ""}${row.lname ? row.lname + " " : "Provider"}`.length > 15
                      ? "..."
                      : ""}
                  </span>
                  <div className="text-left pad-bot-8 pat-details">
                    Patient ID :{" "}
                    <span className="other-details m-l-0-imp">
                      {row.pid ? row.pid : 1}
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <div className="d-flex pat-left-margin m-w-84">
                  <Image
                    height="16px"
                    width="16px"
                    src={Primaryprovider}
                    alt="pic"
                    className="pat-image-right m-t-2"
                  />
                  <span>
                    {row.provider_name ? row.provider_name : "Sample Provider"}
                  </span>
                </div>
                <div className="d-flex pat-left-margin m-w-84">
                  <Image
                    height="16px"
                    width="16px"
                    src={Patientmobile}
                    alt="pic"
                    className="pat-image-right m-t-2"
                  />
                  <span>
                    {row.finalphone ? (
                      <span>
                        {(() => {
                          const { countryCode, phoneNumber } =
                            parsePhoneForDisplay(
                              row.finalphone.replace(/[^0-9+_ ]/g, ""),
                              countryCodes
                            );
                          return `${countryCode} ${phoneNumber}`.trim();
                        })()}
                      </span>
                    ) : (
                      "-"
                    )}
                  </span>
                </div>
                <div className="d-flex pat-left-margin m-w-84 ">
                  <Image
                    height="16px"
                    width="16px"
                    src={Patientemail}
                    alt="pic"
                    className="pat-image-right m-t-4"
                  />
                  <span>{row.finalemail ? row.finalemail : " "}</span>
                </div>
                <div className="d-flex pat-left-margin m-w-84">
                  <Image
                    height="16px"
                    width="16px"
                    src={Patientfax}
                    alt="pic"
                    className="pat-image-right m-t-2"
                  />
                  <span>{row.faxId}</span>
                </div>

                <div className="d-flex">
                  <div className="btn-demo-pat">
                    {storedNames.appt ? (
                      <Button
                        onClick={() => {
                          handleShowApp(row.finalemail);
                        }}
                        style={{ width: "100%", paddingTop: 4 }}
                        className="save_active save-btn create-appt"
                        variant="primary"
                      >
                        Create Appointment
                      </Button>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <PatientSubNav demo={"demo"} />
      </div>
      <Modal
        className="app-popup pat-crt-appt popup_centre custom-modal-width"
        centered
        show={showApp}
        onHide={handleCloseApp}
      >
        {/* <Modal.Header className="c-app" closeButton></Modal.Header> */}
        <NewAppointment
          from="patient_detail"
          onBookAppointment={() => {}}
          getStartApptDate={getStartApptDate}
          providerSelect={[authorized === "1" ? uid : main_pro]}
          pid={params.pid}
          provider={authorized === "1" ? uid : main_pro}
          facility={ufc}
          provarray={provarray}
          facarray={facarray}
          closepopup={handleCloseApp}
          pat_share={storedNames.pat_share}
          savealertmsg={saveAlertMsg}
          popuphide={modClose}
          FetchAppointments={fetchapptdemo}
          setspinnerfornewapp={spinnfunc}
          examroom={true}
          fromDashboard={true}
          redirect={Redirect}
          officeId={
            authorized === "1" ? ufc.toString() : main_facility.toString()
          }
          patEmail={openEmail}
        />
      </Modal>
      <Modal
        className="alert-popup-message"
        show={modalAlerShow}
        onHide={modClose}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          {modalMsg}
        </div>
      </Modal>
      <Modal
        className="user-guide-popup-box"
        show={redirectTo}
        onHide={() => moveTo("redirect")}
      >
        <Modal.Header style={{ borderBottom: "none" }} closeButton>
          <div className="pass-alert-rect">
            <img
              src={rect}
              width="60px"
              height="60px"
              style={{ borderRadius: 8 }}
              alt="ColoredEdge"
            />
          </div>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="expire-modal-heading"
            style={{ fontSize: "19px", marginTop: "0px", marginLeft: "0px" }}
          >
            One Final Step
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p
              className="expire-modal-para"
              style={{
                color: "#4b4b4b",
                marginLeft: "0px",
                fontSize: "16px",
              }}
            >
              Let's Add your Billing Information
            </p>
            <p
              className="expire-modal-para"
              style={{
                color: "#4b4b4b",
                marginLeft: "0px",
                fontSize: "16px",
              }}
            >
              Click continue to add your billing information
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ padding: "20px" }}>
          <Button
            variant="light"
            onClick={() => moveTo("redirect")}
            style={{ margin: "0px 20px 0px 0px", padding: "4.5px 8px" }}
          >
            Cancel
          </Button>
          <Button
            style={{ margin: "0px ", padding: "4.5px 8px" }}
            onClick={() => moveTo("continue")}
          >
            Continue
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default memo(forwardRef(DemographicsPatientDetail));
